import { render, staticRenderFns } from "./fidelior-carousel.vue?vue&type=template&id=45182d56&"
import script from "./fidelior-carousel.vue?vue&type=script&lang=js&"
export * from "./fidelior-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports